"use client";
import { formatPlainYearMonth } from "@sa-nu/shared-utils/date";
import clsx from "clsx";
import type { ComponentProps, Ref } from "react";

import type { MonthGrid } from "../_utils/build-month-grids";

import { MonthCells } from "./month-cells";

type MonthCellsProps = ComponentProps<typeof MonthCells>;

/** 月見出し (sticky) + 日付グリッド */
export function MonthSection({
  grid,
  size,
  backgroundClass,
  dayOfWeekHeaderHeight,
  sectionRef,
  ...monthCellsProps
}: Omit<MonthCellsProps, "cells"> & {
  grid: MonthGrid;
  size: "large" | "small";
  /** sticky 見出しの背景。DatePicker 本体と揃えないと、スクロール時に下の日付セルが透ける */
  backgroundClass: string;
  dayOfWeekHeaderHeight: number;
  sectionRef: Ref<HTMLDivElement>;
}) {
  return (
    <div ref={sectionRef}>
      {/* 月見出し: 曜日ヘッダーの直下に sticky。次の月見出しが来ると押し出される */}
      <div
        data-month-heading
        className={clsx(
          backgroundClass,
          "sticky z-[5] pb-[0px]",
          size === "small" ? "px-[8px] pt-[8px]" : "px-[12px] pt-[12px]",
        )}
        style={{ top: dayOfWeekHeaderHeight }}
      >
        <p
          className={clsx(
            "text-dx-text-default leading-[24px] font-bold whitespace-nowrap",
            size === "small" ? "text-[14px]" : "text-[16px]",
          )}
        >
          {formatPlainYearMonth(grid.yearMonth, { format: "ja" })}
        </p>
      </div>

      {/* 日付グリッド */}
      <MonthCells cells={grid.cells} {...monthCellsProps} />
    </div>
  );
}
